export default "__VITE_ASSET__Ex$uaKGe__"